__turbopack_context__.v({
  "dragHandle": "TrackItem-module__JEuXRG__dragHandle",
  "draggable": "TrackItem-module__JEuXRG__draggable",
  "duration": "TrackItem-module__JEuXRG__duration",
  "even": "TrackItem-module__JEuXRG__even",
  "iconHover": "TrackItem-module__JEuXRG__iconHover",
  "index": "TrackItem-module__JEuXRG__index",
  "indexNumber": "TrackItem-module__JEuXRG__indexNumber",
  "odd": "TrackItem-module__JEuXRG__odd",
  "trackComposer": "TrackItem-module__JEuXRG__trackComposer",
  "trackInfo": "TrackItem-module__JEuXRG__trackInfo",
  "trackItem": "TrackItem-module__JEuXRG__trackItem",
  "trackMeta": "TrackItem-module__JEuXRG__trackMeta",
  "trackTitle": "TrackItem-module__JEuXRG__trackTitle",
});
